<template>
    <div></div>
</template>

<script>
    export default {

        components: {
        },

        data() {
            return {};
        },

        methods: {
        },

        beforeCreate() {
            this.$router.push("/zadmin/login");
        },

        created() {
        },

        beforeMount() {
        },

        mounted() {
        },

        beforeUpdate() {
        },

        updated() {
        },

        beforeDestroy() {
        },

        destroyed() {
        },

    };
</script>
